/* -------------------------------------------------------------------------------- *\
|                               getmainurl
\* -------------------------------------------------------------------------------- */
export default function getmainurl()
{
    return process.env.REACT_APP_SERVER_URL ? process.env.REACT_APP_SERVER_URL : window.location.origin;
}